export const ApptBooking = {
    addService: 'add_service',
    afternoonLabel: 'afternoon',
    bookingDetailsLabel: 'booking_details',
    bookingSummary: 'booking_summary',
    bookNewAppointmentLabel: 'book_new_appointment',
    bookVirtualAppointment: 'virtual_appointment_cta',
    cancelAndStartOverLabel: 'cancel_and_start_over',
    cancellationConfirmationCopy: 'cancellation_confirmation_copy',
    cancellationLabel: 'cancellation',
    confirmationCopy: 'confirmation_copy',
    confirmationLabel: 'confirmation',
    confirmationStepZoomLinkLabel: 'virtual_appointment_confirmation_zoom_link_description',
    editReviewStepLabel: 'edit_review_step',
    eveningLabel: 'evening',
    freeLabel: 'free',
    inStoreConsultationLabel: 'select_store',
    inStoreConsultationCopy: 'physical_appointment_description',
    locationCopy: 'location_copy',
    locationLabel: 'location',
    maxAppointmentServicesCopy: 'max_appointment_services_copy',
    maxAppointmentServicesLabel: 'max_appointment_services',
    minLengthInvalidMessage: 'min_length_message',
    morningLabel: 'morning',
    mustBeANumberLabel: 'must_be_a_number',
    notesLabel: 'notes',
    noTimeslotsAvailableLabel: 'no_timeslots_available',
    noTimeslotsAvailableMessage: 'no_timeslots_available_message',
    phoneLengthLabel: 'phone_length',
    phoneNumberLabel: 'phone_number',
    phoneValidation: 'phone_validation',
    progressLabel: 'progress',
    previousStepLabel: 'previous_step',
    removeService: 'remove_service',
    reviewBookingCopy: 'review_booking_copy',
    reviewBookingLabel: 'review_booking_label',
    scheduleCopy: 'schedule_copy',
    scheduleLabel: 'schedule',
    selectDateCopy: 'select_date_and_time_copy',
    selectDateLabel: 'select_date_and_time',
    selectLocation: 'select_location',
    selectServiceCopy: 'select_service_copy',
    selectServiceHeading: 'select_service',
    selectStore: 'select_store',
    selectStoreCopy: 'select_store_copy',
    selectStoreInstructions: 'select_store_instructions',
    selectStoreLabel: 'select_store',
    serviceCopy: 'service_copy',
    serviceLabel: 'service',
    servicesLabel: 'services',
    whatLabel: 'what',
    whenLabel: 'when',
    whereLabel: 'where',
    selectStoreAllServices: 'book_appointment_main_title_both',
    selectStoreInStoreOnly: 'book_appointment_main_title_physical',
    selectStoreVirtualOnly: 'book_appointment_main_title_virtual',
    virtualConsultationLabel: 'virtual_appointment_title',
    virtualConsultationCopy: 'virtual_appointment_description',
    virtualAppointmentLocationLabel: 'virtual_appointment_location_description',
    virtualConfirmationCopy: 'virtual_appointment_confirmation_description'
};
